<template>
  <div>
    <div class="sticky-nav">
      <input type="checkbox" id="section-toggle">
      <label class="sticky-nav-link mobile show" id="top-button" for="section-toggle">Sections</label>
      <router-link v-for="section in copy.faqs" class="sticky-nav-link desktop"
                   :id="classify(section.topic)+'-button'" :to="'#'+classify(section.topic)"
                   v-on:click.native="toggle">{{ section.topic }}
      </router-link>
      <router-link class="sticky-nav-link desktop"
                   id="what-lsc-election-can-i-vote-in-button" to="#what-lsc-election-can-i-vote-in"
                   v-on:click.native="toggle">Lookup your LSC election
      </router-link>
    </div>
    <div class="section" id="top">
      <Top :copy=copy></Top>
      <div class="text-container">
        <p v-for="p in copy.topA" v-html="md(p)"></p>
      </div>
      <Summary :copy=copy></Summary>
      <!-- <div class="text-container">
        <p v-for="p in copy.topB" v-html="md(p)"></p>
      </div> -->
      <div class=form-background>
        <div class="text-container" id="lsc-form">
          <p data-pym-src="https://s3.amazonaws.com/chalkbeatgraphics/chi-lsc-form-20200921/index.html"><a href="https://s3.amazonaws.com/chalkbeatgraphics/chi-lsc-form-20200921/index.html">Don't see the graphic? Click here.</a></p>
        </div>
      </div>
    </div>
    <div class="faq text-container">
      <div class="section" v-for="section in copy.faqs" :id="classify(section.topic)">
        <h2 class="section-topic">{{ section.topic }}</h2>
        <div class="faq-container" v-for="item in section.questions">
          <h3 v-html="md(item.question)"></h3>
          <div v-for="p in item.answer" class="p-container">
            <p v-html="md(p)"></p>
          </div>
        </div>
      </div>
      <div class="section" id="what-lsc-election-can-i-vote-in">
        <div class="faq-container" >
          <div class="p-container">
            <iframe style="border-style: none;" src="https://my-lsc.datamade.us/" height="600" width="100%" ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  var classify = require("./lib/classify");
  var archieml = require("archieml");
  var md = require("markdown-it")();
  var copy = require("./data/copy.docs.txt");
  copy = archieml.load(copy);
  var Top = require('./components/Top.vue');
  var Summary = require('./components/Summary.vue');

  const RSS_URL = `https://chicago.chalkbeat.org/rss/front-page/index.xml`;

  fetch(RSS_URL)
  .then(response => response.text())
  .then(str => new window.DOMParser().parseFromString(str, "text/xml"))
  .then(data => {
    const items = data.querySelectorAll("entry");
    var articleGroup = document.createElement("Div");
    var articleHeader = document.createElement("H3");
    articleHeader.innerHTML = "The Latest";
    articleGroup.appendChild(articleHeader);
    articleGroup.classList.add("article-group");

    for(var i=0; i < 5; i++){
      var el = items[i];
      var article = document.createElement("Article");
      var title = document.createElement("A");
      var byline = document.createElement("Div");
      title.innerHTML = el.querySelector("title").innerHTML;
      title.href = el.querySelector("id").innerHTML;
      // byline.innerHTML = "By" + el.querySelector("author").innerHTML;
      article.appendChild(title);
      // article.appendChild(byline);
      articleGroup.appendChild(article);
    }

    document.getElementById("app").appendChild(articleGroup);
  });

  module.exports =  {
    name: 'app',
    data(){ return {
      copy: copy,
    } },
    mounted() {
      var elements = document.getElementsByClassName("section");
      // When a new section scrolls into view, turn on the active class for the section link
      window.onscroll = function(){
        for(var i = 0; i != elements.length; i++) {
         if(elements[i].getBoundingClientRect().top <= window.innerHeight*0.62 && elements[i].getBoundingClientRect().top > 0) {
            document.getElementById(elements[i].id+"-button").classList.add("active");
         }
         if(elements[i].getBoundingClientRect().bottom >= window.innerHeight*0.62) {
            document.getElementById(elements[i].id+"-button").classList.add("active");
         }
         if(elements[i].getBoundingClientRect().bottom <= window.innerHeight*0.6) {
            document.getElementById(elements[i].id+"-button").classList.remove("active");
         }
         if(elements[i].getBoundingClientRect().top > window.innerHeight*0.62) {
            document.getElementById(elements[i].id+"-button").classList.remove("active");
         }
        };
      }
    },
    methods: {
      triggerComponent: function(view) {
        this.currentView = view;
      },
      md: function(input) {
        return md.render(input);
      },
      mdInline: function(input) {
        return md.renderInline(input);
      },
      classify: function(input) {
        return classify(input);
      },
      toggle: function(event) {
        var checkbox = document.getElementById('section-toggle');
        checkbox.checked = !checkbox.checked;
      }
    },
    components: {
      Top,
      Summary
    },
  }
</script>

<style scoped></style>
